import httpService from "../../../../services/httpService";

export interface CheckEmailRequest {
  email_address: string;
  entity: string;
}

export interface RegisterRequest {
  company_name: string;
  organization_type: string;
  headquarters_location: string;
  website_url: string;
  email_address: string;
  contact_number: string;
  admin_password: string;
  contact_email_address?: string;
}

export interface LoginRequest {
  email_address: string;
  entity_password: string;
  entity_type: string;
}

export interface ForgotPasswordRequest {
  email_address: string;
  entity_type: string;
}

export interface AdminProfile {
  interviewiq_admin_id: string;
  company_name: string;
  organization_type: string;
  headquarters_location: string;
  website_url: string;
  email_address: string;
  contact_number: string;
  registration_date: string;
  role_name: string;
  contact_email_address?: string;
  subscription_type: string;
  skills?: string[];
  job_categories?: string[];
  logo_url?: string;
  favicon_url?: string;
}

export interface TokenResponse {
  access_token: string;
  token_type: string;
  region: string;
  previous_session?: {
    device: string;
    location: string;
    login_time: string;
  };
}

const AuthClient = {
  checkEmail: async (data: CheckEmailRequest) => {
    const response = await httpService.post<any>("/interview_admin/registration/email", data);
    return response.data;
  },

  register: async (data: RegisterRequest) => {
    const response = await httpService.post<any>("/interviewiq_admin/registration", data);
    return response.data;
  },

  login: async (data: LoginRequest) => {
    const response = await httpService.post<any>("/token", data);
    return response.data;
  },

  getProfile: async () => {
    const response = await httpService.get<any>("/interview_admin/profile");
    return response.data;
  },

  saveProfile: async (data: Partial<AdminProfile>) => {
    const response = await httpService.post<any>("/interview_admin/profile", data);
    return response.data;
  },

  forgotPassword: async (data: ForgotPasswordRequest) => {
    const response = await httpService.post<any>("/password-management/forget", data);
    return response.data;
  },

  resetPassword: async (password: string, secret: string) => {
    const response = await httpService.post<any>(`/password-management/reset?secret=${encodeURIComponent(secret)}`, { password });
    return response.data;
  },

  changePassword: async (password: string) => {
    const email_address = localStorage.getItem("iqadmin_email") || "";
    const entity_type = "INTERVIEWIQ_ADMIN";
    const response = await httpService.post<any>("/password-management/reset", { 
      password,
      email_address,
      entity_type
    });
    return response.data;
  },

  getRegion: async () => {
    const response = await httpService.get<any>("/region");
    return response.data;
  },

  logout: async () => {
    const response = await httpService.post<any>("/logout");
    return response.data;
  },

  uploadLogo: async (formData: FormData | null, queryParams?: string) => {
    const url = queryParams
      ? `/interview_admin/assets/logo?${queryParams}`
      : '/interview_admin/assets/logo';
    const config = formData
      ? { headers: { 'Content-Type': 'multipart/form-data' } }
      : { headers: { 'Content-Type': 'application/json' } };
    const response = await httpService.post<any>(url, formData, config);
    return response.data;
  },
};

export default AuthClient;
